// src/components/admin/settings/ColorsSettings.jsx
import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import './SettingsPages.css';

const ColorsSettings = () => {
  const [settings, setSettings] = useState({
    navbar_color: '#ffffff',
    primary_color: '#667eea',
    secondary_color: '#764ba2',
    background_color: '#ffffff'
  });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    loadSettings();
  }, []);

  const loadSettings = async () => {
    try {
      const response = await fetch('https://demo-site.creativepulse.pk/demo-api/public/get-settings.php');
      const data = await response.json();
      if (data.success && data.settings) {
        setSettings(prev => ({ ...prev, ...data.settings }));
        // Apply colors to the page immediately
        applyColors(data.settings);
      }
    } catch (error) {
      console.error('Error loading settings:', error);
      toast.error('Failed to load colors');
    } finally {
      setLoading(false);
    }
  };

  const applyColors = (colors) => {
    // Apply navbar color
    if (colors.navbar_color) {
      const navbar = document.querySelector('.navbar');
      if (navbar) {
        navbar.style.backgroundColor = colors.navbar_color;
      }
    }

    // Apply background color
    if (colors.background_color) {
      document.body.style.backgroundColor = colors.background_color;
    }

    // Apply primary color to buttons and links
    if (colors.primary_color) {
      const buttons = document.querySelectorAll('.add-to-cart-btn, .btn-primary, .submit-btn');
      buttons.forEach(btn => {
        btn.style.backgroundColor = colors.primary_color;
      });
    }
  };

  const handleChange = (e) => {
    const newValue = e.target.value;
    setSettings({ ...settings, [e.target.name]: newValue });

    // Real-time preview
    if (e.target.name === 'navbar_color') {
      const navbar = document.querySelector('.navbar');
      if (navbar) navbar.style.backgroundColor = newValue;
    }
    if (e.target.name === 'background_color') {
      document.body.style.backgroundColor = newValue;
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const response = await fetch('https://demo-site.creativepulse.pk/demo-api/admin/update-settings-simple.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(settings)
      });
      const data = await response.json();
      if (data.success) {
        toast.success('Colors saved successfully!');
        // Dispatch event to notify other components
        window.dispatchEvent(new Event('settingsUpdated'));
        // Apply colors after saving
        applyColors(settings);
      }
      else {
        toast.error('Failed to save colors');
      }
    } catch (error) {
      console.error('Save error:', error);
      toast.error('Connection error');
    } finally {
      setSaving(false);
    }
  };

  if (loading) return <div className="loader">Loading colors...</div>;

  return (
    <div className="settings-page">
      <h2>Colors Settings</h2>
      <p className="section-description">Customize your store's color scheme</p>

      <form onSubmit={handleSubmit} className="settings-form">
        <div className="color-grid">
          <div className="form-group">
            <label>Navbar Color</label>
            <div className="color-input-wrapper">
              <input
                type="color"
                name="navbar_color"
                value={settings.navbar_color}
                onChange={handleChange}
              />
              <span className="color-hex">{settings.navbar_color}</span>
            </div>
          </div>
          <div className="form-group">
            <label>Primary Color</label>
            <div className="color-input-wrapper">
              <input
                type="color"
                name="primary_color"
                value={settings.primary_color}
                onChange={handleChange}
              />
              <span className="color-hex">{settings.primary_color}</span>
            </div>
          </div>
          <div className="form-group">
            <label>Secondary Color</label>
            <div className="color-input-wrapper">
              <input
                type="color"
                name="secondary_color"
                value={settings.secondary_color}
                onChange={handleChange}
              />
              <span className="color-hex">{settings.secondary_color}</span>
            </div>
          </div>
          <div className="form-group">
            <label>Background Color</label>
            <div className="color-input-wrapper">
              <input
                type="color"
                name="background_color"
                value={settings.background_color}
                onChange={handleChange}
              />
              <span className="color-hex">{settings.background_color}</span>
            </div>
          </div>
        </div>
        <button type="submit" disabled={saving} className="save-btn">
          {saving ? 'Saving...' : 'Save Colors'}
        </button>
      </form>
    </div>
  );
};

export default ColorsSettings;